import('./style.scss')
import Search from './search'

export default Search